export const SEARCH_FIELDS = ['ContactID', 'FirstName', 'LastName']
